import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'styles/util';
import clsx from 'clsx';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles(({ theme }) => ({
    container: {
        display: 'flex',
        gap: theme.spacing(0.625),
        alignItems: 'center',
        justifyContent: 'center'
    },
    icon: {
        display: 'flex',
        flex: '0 0 auto',
        paddingRight: theme.spacing(0.5),
        alignItems: 'center'
    },
    children: {
        flex: '0 1 auto'
    },
    singleLineHeight: {
        height: '1rem'
    }
}));

const IconPrefix = ({ icon, className, singleLineHeight, children, alt = '' }) => {
    const classes = useStyles();

    return (
        <Box className={clsx(classes.container, className)}>
            <Box className={clsx(classes.icon, { [classes.singleLineHeight]: singleLineHeight })}>
                {
                    typeof icon === 'string' ?
                        <img src={icon} height="24" width="24" alt={alt}/>
                        :
                        icon
                }
            </Box>
            <Box className={classes.children} component="span">
                {children}
            </Box>
        </Box>
    );
};

IconPrefix.propTypes = {
    icon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
    className: PropTypes.string,
    singleLineHeight: PropTypes.bool,
    children: PropTypes.node.isRequired,
	alt: PropTypes.string
};

export default IconPrefix;
